import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import { Utils, domainVal, NumberFormatter, i18n, DateFormatter, isAuth } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import { rejects } from 'assert';
import { isNullOrUndefined } from 'util';
import Upload from './upload.jsx'
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx'
import { resolve } from 'path';


class MicroCategoriaDocument extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[MicroCategoriaDocument.jsx] ';
        this.state = {
            showConfirm: false,
            showConfirmDelete: false,
            microCategoriaDaEliminare: null,
            ordersList: [],
            showConfirmModifica: false,
            document: {}
        }
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.showConfirmDelete = this.showConfirmDelete.bind(this);
        this.deleteMicroCategoriaDocument = this.deleteMicroCategoriaDocument.bind(this);
        this.showConfirmPanelModifica = this.showConfirmPanelModifica.bind(this);
        this.modificaMicroCategoriaDocument = this.modificaMicroCategoriaDocument.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        //definisco le colonne della boostrap table
        let columns = [
            { field: 'ordVis', title: i18n('ARM_CORE_PRODUCT.MANAGE.ORDINE', '#'), align: "center", sortable: 'true' },
            { field: 'name', title: i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome'), align: "center", sortable: 'true' },
            { field: 'metadata', title: i18n('ARM_CORE_PRODUCT.MANAGE.TYPE', 'Tipo'), align: "center", sortable: 'true' },
            { field: 'countDownload', title: i18n('ARM_CORE_PRODUCT.MANAGE.DOWNLOAD_COUNT', 'Download Count'), align: "center", sortable: 'true' },
            { field: 'dateCre', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA_CREAZIONE', 'Data Creazione'), align: "center", sortable: 'true', formatter: this.dateFormatter },
            { field: 'download', title: i18n('ARM_CORE_PRODUCT.SHARED.DOWNLOAD', 'Scarica'), align: "center", formatter: this.columnDownload },
            { field: 'edit', align: 'center', title: i18n("ARM_CORE_PRODUCT.SHARED.MODIFICA", "Modifica"), formatter: this.columnEdit },
            { field: 'elimina', align: 'center', title: i18n("ARM_CORE_PRODUCT.SHARED.ELIMINA", "Elimina"), formatter: this.columnDelete },

        ];



        $(this.refs.MyTable).bootstrapTable({
            columns: columns,
            idField: "idMicroCategoriaDocument",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.downloadOnClick(row, $element, field),
            sortOrder: "desc",
            pagination: true,


        });

        if (this.props.rows !== null && this.props.rows !== undefined) {

            $(this.refs.MyTable).bootstrapTable('load', this.props.rows);
        }
    }

    downloadOnClick(row, $element, field) {
        console.log(this.componentName + " showConfirmPanel()");

        if (field === "download") {
            let path = "document/download/" + row.docId;
            this.props.downloadDocument(path);
        } else if (field === "elimina") {
            this.inzializzaEliminaDocument(row.idMicroCategoriaDocument);
        } else if (field === "edit") {
            this.setState({
                document: row,
                showConfirmModifica: true
            })
        }


    }

    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    dateFormatterShort(value, row, index) {
        return DateFormatter.dataFormatterShort(value);
    }

    columnEdit(value, row, index) {
        console.log(this.componentName + " columnEdit: " + index);
        let temp;
        temp = "<button class='btn btn-primary btn-sm'><i class='fas fa-edit fa-fw' data-toggle='tooltip' data-placement='top' title='Modifica'/></button>";
        return temp;
    }

    showConfirmPanelModifica() {
        this.setState({ showConfirmModifica: !this.state.showConfirmModifica });
    }

    columnDelete(value, row, index) {
        console.log(this.componentName + " columnDelete: " + index);
        let temp;
        temp = "<button class='btn btn-danger btn-sm'><i class='fas fa-trash-alt' data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
        return temp;
    }

    ordVisFormatter(value, row, index) {
        console.log(this.componentName + " ordVisFormatter: " + index);
        let returnValue = "-"
        if (row && row.properties) {
            let properties = row.properties;
            let propertyArray = properties.split(';');
            if (propertyArray) {
                propertyArray.forEach(element => {
                    if (element && element.split('=') && element.split('=')[0] === "ordVis") {
                        returnValue = Number(element.split('=')[1]);

                    }
                });
            }
            return returnValue;
        }

    }

    inzializzaEliminaDocument(idMicroCategoriaDocument) {

        this.setState({ microCategoriaDaEliminare: idMicroCategoriaDocument, showConfirmDelete: true });

    }

    showConfirmDelete() {
        this.setState({ showConfirmDelete: !this.state.showConfirmDelete });
    }

    deleteMicroCategoriaDocument() {

        this.showConfirmDelete();

        this.props.deleteMicroCategoriaDocument(this.state.microCategoriaDaEliminare).then(

            resolve => {
                this.props.getListaDocumenti(this.props.idMicroCategoria)
            }
        )
    }

    showConfirmPanel() {
        console.log(this.componentName + " showConfirmPanel()");

        this.setState({ showConfirm: !this.state.showConfirm })

    }

    columnDownload(value, row, index) {
        console.log("columnDownload:" + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fas fa-download'></i></button>";
        return temp;
    }


    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.rows !== this.props.rows) {
            console.log("\t rows: " + (nextProps.rows !== null ? nextProps.rows.length : "NULL"));
            let ordersList = [];
            if (nextProps.rows === null) {
                $(this.refs.MyTable).bootstrapTable('removeAll');
            } else {

                $(this.refs.MyTable).bootstrapTable('load', nextProps.rows);
                nextProps.rows.forEach((element, index) => {
                    ordersList.push({ value: index + 1 });
                });
            }
            this.setState({ ordersList: ordersList })
        }
    }

    inputChangeHandler(e) {

        let id = e.target.id;
        let value = e.target.value;
        let object = this.state.document;
        object[id] = value;
        this.setState({ document: object });
    }

    modificaMicroCategoriaDocument() {
        let id = this.state.document.idMicroCategoriaDocument;
        let ordVis = this.state.document.ordVis ? this.state.document.ordVis : 0;
        let oldOrdVis = this.state.document.oldOrdVis ? this.state.document.oldOrdVis : 0;

        this.showConfirmPanelModifica();
        this.props.modificaMicroCategoriaDocument(id, ordVis, oldOrdVis, this.props.idMicroCategoria).then(
            resolve => {
                this.props.getListaDocumenti(this.props.idMicroCategoria)
            }
        )
    }

    dynamicSort(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        }
    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div className="mt-3">
                {isAuth('V2.ADMIN.PRODUCT.DOC_EDIT') &&
                    <agui.aButton bs="primary" className="mr-3" icon="fas fa-upload" onClick={this.showConfirmPanel}>{i18n('ARM_CORE_PRODUCT.SHARED.NUOVO', 'Nuovo')}</agui.aButton>
                }
                <table ref="MyTable" className={AppConstants.CLASS_TABLE} />

                <Upload idMicroCategoria={this.props.idMicroCategoria} show={this.state.showConfirm} close={this.showConfirmPanel}
                />

                <agui.ConfirmModalOkCancelV4 show={this.state.showConfirmModifica} >
                    <agui.ConfirmModalOkCancelV4.Header testoTitle={i18n("ARM_CORE_PRODUCT.SHARED.MODIFICA", "Modifica")} onClose={this.showConfirmPanelModifica} />
                    <agui.ConfirmModalOkCancelV4.Body>
                        <div className="row mt-1 mb-3 ">

                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ASelectV4
                                    id="ordVis"
                                    addEmptyOption={false}
                                    onChange={this.inputChangeHandler}
                                    value={this.state.document.ordVis}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.ORDINE_VIS', 'Ordine visibilità')}
                                    items={this.state.ordersList}
                                    valueKey="value"
                                    labelKey="value"
                                />
                            </div>

                        </div>

                    </agui.ConfirmModalOkCancelV4.Body >
                    <agui.ConfirmModalOkCancelV4.Footer
                        testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                        confirmOnClick={this.modificaMicroCategoriaDocument}
                        onClose={this.showConfirmPanelModifica}>
                    </agui.ConfirmModalOkCancelV4.Footer>
                </agui.ConfirmModalOkCancelV4>
                <ConfirmModalDeleteV4
                    show={this.state.showConfirmDelete}
                    deleteOnClick={this.deleteMicroCategoriaDocument}
                    onClose={this.showConfirmDelete} />
            </div>
        );
    }
};



export default MicroCategoriaDocument;
